module.exports = __webpack_public_path__ + "assets/5919b8ff29c73385288a142f367fcef9.mp3";